import { Component, Input, OnInit, OnChanges, HostBinding, EventEmitter, Output, AfterViewInit, ElementRef, SimpleChanges } from '@angular/core';
import { QueryCondition } from '../../entity/querycondition';
import { SolutionService } from '../../service/solution.service';

@Component({
    selector: 'app-filter-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss']
})

export class InputComponent implements OnInit, OnChanges, AfterViewInit {

    /**
     * QueryCondition类型
     */
    @Input() item: any;
    @Input() autoLabel: boolean;
    @Input() disabled: boolean;
    @Output('searchHandle') searchHandle = new EventEmitter();

    /**判断是否是在扩展区域展示 */
    extend: boolean = false;
    /**判断是否显示label */
    showlabel: boolean = true;
    placeholder: string;

    @HostBinding('class.filter-item-wrap')
    get isExtend(): boolean {
        return !this.extend && this.autoLabel;
    }
    @HostBinding('class.filter-item-hiddenlabel')
    get hidenLabel(): boolean {
        return !this.showlabel;
    }

    constructor(private solutionService: SolutionService, private readonly element: ElementRef) { }

    ngOnInit(): void {
        //console.log(this.item);
        if (this.item) {
            const type = Object.prototype.toString.call(this.item.placeHolder);
            if (type == '[object Undefined]') {
                if (this.item.control && this.item.control.hasOwnProperty('placeholder')) {
                    this.placeholder = this.item.control.placeholder;
                }
            }
            else {
                this.placeholder = this.item.placeHolder;
            }
        }
        if (this.item && this.item.control && this.item.control.hasOwnProperty('isExtend')) {
            this.extend = this.item.control.isExtend;
            if (!this.extend) {
                this.showlabel = this.item.control.showLabel;
            }
        }
        this.solutionService.addFilterEditorInstance(this.item.fieldCode, this);

        // (this.item.value as HelpValue).clear$.subscribe(() => {
        //     this.textValue = '';
        // });
    }
    ngAfterViewInit() {
        // if(!this.extend){
        //     const El = this.element.nativeElement;
        //     const itemWidth = El.clientWidth;
        //     El.querySelector('.list-filter-input-item').style.width = itemWidth + 'px';
        //     El.querySelector('.input-item-btns').style.width = itemWidth + 100 + 'px';
        // }
    }
    ngOnChanges(): void {
    }

    // getConditionItemStyle(field: QueryCondition, controlType: any) {
    //     return this.solutionService.getConditionItemStyle(field,controlType);
    // }

    getConditionItemTitle(field: QueryCondition) {
        return this.solutionService.getConditionItemTitle(field);
    }

    InputChanged(e) {
        // let keycode = window.event ? e.keyCode : e.which;
        // if(keycode == 13){//回车键
        //     this.searchHandle.emit(this.item.value.value);
        // }
        if (this.disabled) { return; }
        this.searchHandle.emit(this.item.value.value);
    }
}